export class InfosCertificatModel {
  sessionId!: number;
  utilisateurId!: number;
  titreFormation!: string;
  nomCertificat!: string;
  prenomNomUtilisateur!: string;
  nomEntite!: string;
  adresseEntite!: string;
  dateFormation!: Date;
  dateImpression!: Date;
  numeroAttestion!: string;
  typeCertificat!: string;
  codeLangue!: string;
  estSessionGroupe?: boolean | null;

  constructor(sessionid: number, utilisateurId: number) {
    this.sessionId = sessionid;
    this.utilisateurId = utilisateurId;
  }
}
